// Action Subject Ids
export const CREATE_APP = 'createApp';
export const TOGGLE_LOYALTY_DISCOUNT = 'toggleLoyaltyDiscount';
export const PARTNER_DETAILS_FORM_INPUT = 'changePartnerDetailFormInput';
export const MANAGE_PARTNER_DETAILS_FORM = 'managePartnerDetailsForm';
export const ADD_PARTNER_CONTACT = 'addPartnerContact';
export const REMOVE_PARTNER_CONTACT = 'removePartnerContact';
export const MANAGE_PARTNER_CONTACTS_PERMISSION = 'managePartnerContactsPermission';
export const SUBMIT_PARTNER_CONTACTS_PERMISSION = 'submitManageContactsPermission';
export const CREATE_PROMOTION = 'createPromotion';
export const CHANGE_PROMOTION_INFO_FILTER = 'changePromotionInfoFilter';
export const SUBMIT_PARTNER_PAYMENT_FORM = 'submitPartnerPaymentForm';
export const SUBMIT_PARTNER_ADMIN_FORM = 'submitPartnerAdminForm';
export const REPORT_SECURITY_INCIDENT = 'reportSecurityIncident';
export const APPLY_SECURITY_SELF_ASSESSMENT = 'applySecuritySelfAssessment';
export const MANAGE_PARTNER_TAB = 'managePartnerTab';
export const NAVIGATE_PARTNER_REPORTING_TAB = 'navigateReportingTab';
export const PARTNER_REPORTS_MORE_FILTER = 'reportingMoreFilter';
export const PARTNER_REPORTS_PERIOD = 'reportingPeriod';
export const PARTNER_REPORTS_TEXT_SEARCH = 'reportingTextSearch';
export const PARTNER_REPORTS_EXPORT_CSV = 'reportingExportCsv';
export const PARTNER_REPORTS_EXPORT_JSON = 'reportingExportJson';
export const PARTNER_REPORTS_AGGREGATES_TAB = 'aggregateReportingTab';
export const PARTNER_REPORTS_AGGREGATE_GROUP_BY = 'aggregateReportingGroupBy';
export const PARTNER_REPORTS_SALES_UNIT_SELECTOR = 'reportingSalesUnit'; // Event Containers

export const MANAGE_PARTNER_APPS_VIEW = 'managePartnerAppsView';
export const MANAGE_PARTNER_DETAILS_VIEW = 'managePartnerDetailsView';
export const MANAGE_PARTNER_CONTACTS_VIEW = 'managePartnerContactsView';
export const MANAGE_PARTNER_PROMOTION_VIEW = 'managePartnerPromotionView';
export const MANAGE_PARTNER_PAYMENT_INFO_FORM = 'managePartnerPaymentInfoForm';
export const MANAGE_PARTNER_ADMIN_VIEW = 'managePartnerAdminView';
export const MANAGE_PARTNER_REPORTS_VIEW = 'managePartnerReportsView';
export const MANAGE_PARTNER_SECURITY_VIEW = 'managePartnerSecurityView'; // Promotions

export const ANALYTICS_SUBJECT_ID_CREATE_PROMOTION = 'createPromotion';
export const ANALYTICS_SUBJECT_ID_VIEW_PROMOTION_DETAILS = 'viewPromotionDetails';
export const ANALYTICS_SUBJECT_ID_PROMOTION_LIST_FILTER = 'promotionListFilters';
export const ANALYTICS_SUBJECT_ID_EDIT_PROMOTION = 'editPromotion';
export const ANALYTICS_SUBJECT_ID_SAVE_PROMOTION = 'savePromotion';
export const ANALYTICS_SUBJECT_ID_END_PROMOTION = 'endPromotion';
export const ANALYTICS_SUBJECT_ID_CREATE_PROMOTION_CODE = 'createPromotionCode';
export const ANALYTICS_SUBJECT_ID_DELETE_PROMOTION_CODE = 'deletePromotionCode';